import { Link } from "react-router-dom";
import { Sparkles, Instagram, Facebook } from "lucide-react";

const POLICIES = [
  { label: "Privacy Policy", to: "/policies/privacy" },
  { label: "Terms of Service", to: "/policies/terms" },
  { label: "Refund Policy", to: "/policies/refund" },
  { label: "Digital Product Policy", to: "/policies/digital" },
  { label: "Photo Upload & Retention", to: "/policies/photos" },
  { label: "Copyright Policy", to: "/policies/copyright" },
];

const SHOP = [
  { label: "All Products", to: "/shop" },
  { label: "Instant Downloads", to: "/shop?instant=true" },
  { label: "Free Preview", to: "/free-preview" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "FAQ", to: "/faq" },
];

export default function Footer() {
  return (
    <footer className="bg-slateink text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 rounded-lg bg-amber flex items-center justify-center text-white"><Sparkles className="w-4 h-4" /></span>
            <span className="font-display text-lg font-bold text-white">Made For Me Studio</span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-xs">Personalized digital gifts, made just for you. Turn the moments you love into keepsakes.</p>
          <div className="flex gap-3 mt-4">
            {[["Instagram", Instagram], ["TikTok", null], ["Pinterest", null], ["Facebook", Facebook]].map(([n, Icon]) => (
              <a key={n} href="#" aria-label={n} data-testid={`social-${n.toLowerCase()}`}
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-amber flex items-center justify-center text-white transition-colors text-xs font-semibold">
                {Icon ? <Icon className="w-4 h-4" /> : n[0]}
              </a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Shop</h4>
          <ul className="space-y-2">{SHOP.map((s) => (
            <li key={s.label}><Link to={s.to} className="text-sm text-slate-400 hover:text-amber transition-colors">{s.label}</Link></li>
          ))}</ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Policies</h4>
          <ul className="space-y-2">{POLICIES.map((s) => (
            <li key={s.label}><Link to={s.to} className="text-sm text-slate-400 hover:text-amber transition-colors">{s.label}</Link></li>
          ))}</ul>
        </div>
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Studio</h4>
          <ul className="space-y-2">
            <li><Link to="/blog" className="text-sm text-slate-400 hover:text-amber transition-colors">Blog</Link></li>
            <li><Link to="/account" className="text-sm text-slate-400 hover:text-amber transition-colors">My Account</Link></li>
            <li><Link to="/free-preview" className="text-sm text-slate-400 hover:text-amber transition-colors">Free Preview</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Made For Me Studio. Crafted with care by The Made For Me Studio Team.
      </div>
    </footer>
  );
}
